import m1_examRegMenu from "@components/excuseMenu/m1_examRegMenu";
import m2_examRegMenu from "@components/excuseMenu/m2_examRegMenu";
import m2Sidebar from "@components/sidebar/m2_sidebar";
import m1_subExamRegMenu from '@components/subExamRegMenu/m1_subExamRegMenu.vue'
import m2_subExamRegMenu from '@components/subExamRegMenu/m2_subExamRegMenu.vue'
export default{
    components: {
        'm2ExamRegMenu':m2_examRegMenu,
        "m2Sidebar":m2Sidebar,
        "m1ExamRegMenu":m1_examRegMenu,
        "m1SubExamRegMenu":m1_subExamRegMenu,
        "m2SubExamRegMenu":m2_subExamRegMenu
    },
    data(){
        return {
            fileList: [],
            field: [],
            validResult: true,
            btnDisable:false,
            tempFileType: [],

        }
    },
    methods: {
        setTip(tip){
            if(tip){
                return tip.replace('\n','<br>')
            }
            else {
                return ""
            }
        },
        getData: function () {
            const uuidv1 = require('uuid/v1');
            let examRegInfo = this.$store.state.examRegInfo.examRegInfo;
            if (examRegInfo === null) {
                this.$router.push({name: 'excuseExam.chooseBatch'});
            }
            if (examRegInfo.file_info_confs === null) {
                this.$router.push({name: 'excuseExam.chooseBatch'});
            }
            this.field = examRegInfo.file_info_confs;
            let passLength=0;
            for (let item of  this.field) {
                this.displayRule(item);
                if(item.is_pass){
                    passLength++
                }
                this.fileList.push([]);
                if (item.value) {
                    this.getImgUrl(item.value, this.field.indexOf(item))
                }
                else {
                    item.value=uuidv1();
                }
            }
            if(passLength==0){
                if(this.$store.state.examRegInfo.backOrNextStep=='next'){
                    this.nextStep();
                }
                else {
                    this.preStep()
                }
            }
        },
        displayRule(item){
            let text_info_confs = this.$store.state.examRegInfo.examRegInfo.text_info_confs;
            if(item.rules.length>0){
                for(let i of item.rules){
                    for(let j of  text_info_confs){
                        if(j.tag==i.tag){
                            if(displayRuleType[i.condition]){
                                if(j.type==3){
                                    let states=true;
                                    for(let option of i.value){
                                        if(j.value.indexOf(option)==-1){
                                            states=false;
                                        }
                                    }
                                    if(!states){
                                        item.value='';
                                        item.is_pass=false;
                                        return false
                                    }
                                }
                                else{
                                    if(i.value.indexOf(j.value)==-1){
                                        item.value='';
                                        item.is_pass=false;
                                        return false
                                    }
                                }
                            }
                            else {
                                if(!j.value){
                                    item.value='';
                                    item.is_pass=false;
                                    return false
                                }
                            }
                        }
                    }
                }
                item.is_pass=true;
                return true
            }
            else {
                item.is_pass=true;
                return true
            }
        },
        computerNumber(num, type){
            let Node = {
                No_Restrict: '1',
                PDF: '2',
                Word: '4',
                PPT: '8',
                JPG: '16',
                PNG: '32',
                Excel:'64',
            };
            let contentType = {
                No_Restrict: '',
                PDF: 'application/pdf',
                Word: 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                PPT: 'application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
                Excel:'application/vnd.ms-excel'
            };
            let format = [];
            for (let item in Node) {
                if ((num & Node[item]) == parseInt(Node[item])) {
                    format.push(item);
                }
            }
            if (type === 1) {
                let string = '';
                for (let i in format) {
                    if (i == (format.length - 1)) {
                        string = string + format[i];
                    }
                    else {
                        string = string + format[i] + ',';
                    }
                }
                return string;
            }
            else {
                let string = '';
                for (let i in format) {
                    if (i == (format.length - 1)) {
                        string = string + contentType[format[i]];
                    }
                    else {
                        string = string + contentType[format[i]] + ',';
                    }
                }
                return string;
            }
        },
        beforeAvatarUpload(file){
            const isLt1M = file.size / 1024 / 1024 <= 5;
            const isJPG = file.type === 'application/vnd.ms-powerpoint'||file.type ==='application/vnd.ms-excel'||file.type ==='application/vnd.openxmlformats-officedocument.presentationml.presentation'||file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword' || file.type === 'application/pdf';
            if (!isJPG) {
                this.$alert('请上传正确格式的文件', {confirmButtonText: '确定',});
                return false;
            }
            if (!isLt1M) {
                this.$alert('文件过大，请上传5M以内的文件', {confirmButtonText: '确定',});
                return false;
            }
            return true;
        },
        handleExceed() {
            this.$alert('超出文件数量')
        },
        handleChange(file, fileList) {
            this.tempFileType=fileList;
        },
        upload: function (_upload) {
            let type = this.computerNumber(
                _upload.data.item.sub_confs[0].support_types,
                2
            );
            if (type.indexOf(_upload.file.type) == -1) {
                this.$alert('请上传正确格式的文件', {
                    confirmButtonText: '确定',
                })
                this.tempFileType.pop()
            } else {
                _upload.data.callback(_upload);
            }
        },
        uploadCallback: function (_upload) {
            let index = this.field.indexOf(_upload.data.item);
            this.$http.post(globalProvider.serviceUrl('oss/_f/g/lk/up/pc'), {
                proc_id: _upload.data.item.value,
                file_name: _upload.file.name,
                type: _upload.file.type,
            }).then((data) => {
                if (data.body.code == resultCode.Success) {
                    let uploadUrl = data.body.data.link;
                    this.field[index].value = data.body.data.proc_id;
                    let file_id = data.body.data.file_guid;
                    this.$http.put(uploadUrl, _upload.file, {
                        headers: {
                            'Content-Type': _upload.file.type,
                            "Content-Disposition":"attachment;filename="+encodeURI(_upload.file.name)
                        },
                    }).then((response) => {
                        if (response.status == 200) {
                            _upload.onSuccess(1)
                            if (this.fileList[index].length <= _upload.data.item.sub_confs[0].upper_limit) {
                                this.fileList[index].push({
                                    name: _upload.file.name,
                                    file_id: file_id
                                })
                            }
                        }
                        else {
                          _upload.onError(1)
                        }
                    })
                }
                else if (data.body.code == resultCode.NotSuccess) {
                    _upload.onError(1)
                    this.$alert(getErrorMessage(data.body.message));
                }
            });
        },
        
        getImgUrl: function (proc_id, id) {
            if (proc_id != null) {
                this.$http.get(globalProvider.serviceUrl('oss/_f/g/lk/dl/{proc_id}'), {params: {proc_id: proc_id,loading:true}})
                    .then((data) => {
                        if (data.body.code == resultCode.Success) {
                            for (let item of  data.body.data) {
                                this.fileList[id].push({
                                    file_id:item.file_guid,
                                    name: item.name,
                                })
                            }
                        }
                        else if (data.body.code == resultCode.NotSuccess) {
                            this.$alert(getErrorMessage(data.body.message));
                        }
                    });
            }
        },
        removeFile(file, fileList){
            this.$http.post(globalProvider.serviceUrl('oss/_f/d/lk/single'), {
                file_guid: file.file_id
            }).then((data) => {
                if (data.body.code == resultCode.Success) {
                    for (let item of  this.fileList) {
                        if(item.indexOf(file)>-1){
                            let index=this.fileList.indexOf(item)
                            this.fileList[index].splice(item.indexOf(file),1)
                        }
                    }
                }
            })
        },
        checkData: function (callback) {
            this.validResult = true;
            this.field.forEach((item,index) => {
                if(item.is_pass){
                    if (item.is_required) {
                        if (this.fileList[index].length == 0) {
                            this.validResult = false;
                            return;
                        }
                    }
                }
            })
            callback && callback();
        },
        preStep: function () {
            this.$store.commit('setBackOrNextStep','back');
            let RegInfoModel = this.$store.state.examRegInfo.examRegInfo;
            if (RegInfoModel.pic_info_confs.length > 0) {
                this.$router.push({name: 'excuseExam.imgCollection'});
            }
            else if (RegInfoModel.text_info_confs.length > 0) {
                this.$router.push({name: 'excuseExam.baseCollection'});
            }
            else {
                this.$router.push({name: 'excuseExam.examNotes'});
            }
        },
        nextStep: function () {
            this.btnDisable=true;
            let examRegInfo = this.$store.state.examRegInfo.examRegInfo;
            this.checkData(() => {
                    if (this.validResult) {
                        this.btnDisable=false;
                        this.$store.commit('setExamRegInfoItem', {file_info_confs: this.field});
                        let st = []
                        for(let item of this.field){
                            if(item.is_pass){
                                st.push(item)
                            }
                        }
                        this.$http.post(globalProvider.serviceUrl('ex_exm/us/rgsi/f'), {
                            eri: examRegInfo.exam_registration_id,
                            i: st
                        })
                            .then((data) => {
                                if (data.body.code === resultCode.Success) {
                                    this.$router.push({name: 'excuseExam.submitRegInfo'});
                                }
                                else if (data.body.code == resultCode.NotSuccess){
                                    this.$alert(getErrorMessage(data.body.message));
                                }
                            })
                    }
                    else {
                        this.btnDisable=false;
                        this.$alert('请上传文件', {confirmButtonText: '确定',});
                    }
                }
            )
        }
    },
    created: function () {
        this.$store.commit('setHeaderState', '3');
        this.getData();
    }
}